var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stock-management-navbar" },
    [
      _c("div", { staticClass: "left-navbar" }, [
        _c(
          "div",
          { staticClass: "logo-badge" },
          [
            _c("WeezieLogo", {
              staticClass: "back-button",
              on: { click: _vm.backToHub }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "page-name" }, [
          _vm._v("\n      " + _vm._s(_vm.pageName) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.closeWindow,
              expression: "closeWindow"
            }
          ],
          staticClass: "right-navbar"
        },
        [
          _c(
            "v-layout",
            {
              attrs: {
                row: "",
                "justify-end": "",
                "align-center": "",
                id: "badge"
              }
            },
            [
              _c(
                "v-badge",
                {
                  staticClass: "notifications-badge",
                  attrs: {
                    content: null,
                    value: _vm.messages.length,
                    color: "red",
                    dot: "",
                    overlap: ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: { click: _vm.onNotificationButtonClick }
                    },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "#231E46", size: "0.65rem" } },
                        [_vm._v(" notifications_none ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("UserButton", {
            staticClass: "navbar-user-button",
            attrs: {
              avatarWidth: "1.5rem",
              avatarHeight: "1.5rem",
              nameSize: "8px",
              id: "userButton"
            },
            nativeOn: {
              click: function($event) {
                return _vm.onUserButtonClick.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slide-fade" } },
            [
              _c("notifications-window", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.notificationWindow,
                    expression: "notificationWindow"
                  }
                ],
                attrs: {
                  right: _vm.width,
                  top: "35px",
                  notificationOpen: _vm.notificationWindow
                },
                on: { notifications: _vm.setNotificationNumber }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("UserWindow", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.userWindow,
                expression: "userWindow"
              }
            ],
            attrs: { right: "15px", top: "40px" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("ActivateTwoAuthenticationDialog", {
        attrs: { open: _vm.opened2FArequired },
        on: {
          close: function($event) {
            _vm.opened2FArequired = false
          },
          activateAuthenticate: function($event) {
            _vm.twoFactorAuthentication = true
          }
        }
      }),
      _vm._v(" "),
      _c("div")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-153b5abb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-153b5abb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Organisms/NavBar.vue
// module id = null
// module chunks = 